/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import SubjectStepModel from 'cio/models/subject-step';
import { BatchUpdateTemplateType } from 'cio/utils/actions/batch-update';

type SubjectStepDescriptionContentBatchUpdateActionArgs = {
  step: SubjectStepModel;
};

const PAST_BATCH_UPDATE_TYPE_DESCRIPTIONS: Record<BatchUpdateTemplateType, string> = {
  [BatchUpdateTemplateType.AttributeUpdate]: 'Batch update attribute change',
  [BatchUpdateTemplateType.CreateEvent]: 'Batch update event sent',
};

const FUTURE_BATCH_UPDATE_TYPE_DESCRIPTIONS: Record<BatchUpdateTemplateType, string> = {
  [BatchUpdateTemplateType.AttributeUpdate]: 'Batch update attribute change',
  [BatchUpdateTemplateType.CreateEvent]: 'Batch update event send',
};

export default class SubjectStepDescriptionContentBatchUpdateAction extends Component<SubjectStepDescriptionContentBatchUpdateActionArgs> {
  get batchUpdateTypeString() {
    let action = this.args.step.belongsTo('action').value() as ActionModel | null;

    if (action == null) {
      return null;
    }

    let descriptions = this.args.step.future
      ? FUTURE_BATCH_UPDATE_TYPE_DESCRIPTIONS
      : PAST_BATCH_UPDATE_TYPE_DESCRIPTIONS;
    return descriptions[action.templateType as BatchUpdateTemplateType] ?? null;
  }
}
